var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.6ef96c8d8e4cb429039f383ba4ae8fac.svg#C';
                    var viewUrl = 'sprites.6ef96c8d8e4cb429039f383ba4ae8fac.svg#view-C';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 34 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };